"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.BurgerMenuInner = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _BurgerMenu = require("../BurgerMenu");
const Root = exports.Root = (0, _mui.styled)('aside')(({
  theme
}) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    backgroundColor: theme.palette.common.white,
    transition: `top ${_presentationUtils.CSS_HEIGHT_ANIMATION}`,
    boxShadow: _mui.SHADOW_LEVEL1,
    display: 'flex',
    left: 0,
    maxWidth: 'min(1040px, calc(100% - 40px))',
    minHeight: `min(590px, ${_BurgerMenu.DESKTOP_BURGER_MENU_HEIGHT})`,
    position: 'absolute',
    top: `calc(${_presentationUtils.CSS_DESKTOP_INNER_HEIGHT} + ${_presentationUtils.TOP_AREA_NAVIGATION_HEIGHT}px)`
  }
}));
const BurgerMenuInner = exports.BurgerMenuInner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  width: 'inherit',
  maxHeight: _BurgerMenu.DESKTOP_BURGER_MENU_HEIGHT,
  overflowX: 'hidden',
  overflowY: 'auto'
}));
